import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";

export enum PackingGroup {
	"I" = "High danger",
	"II" = "Medium danger",
	"III" = "Low danger"
}

export const ProductPackingGroup = ({ value, onChange }: Omit<SelectProps<keyof typeof PackingGroup, false>, "fetchOptions">) => {
	return <Select
		disableSearch
		fetchOptions={Object.keys(PackingGroup)}
		getOptionLabel={opt => PackingGroup[opt as keyof typeof PackingGroup]}
		multiple={false}
		value={value}
		onChange={val => onChange?.(val as keyof typeof PackingGroup, false)}
	/>;
};
